export default "__VITE_ASSET__DOIv5Ghc__"